import React, { useState } from "react";
import usePost from "../../customHooks/usePost/UsePost";
import CustomToast from "../../atomic/customToast/CustomToast";
import { countries } from "../../data/navBar/Country";

export default function AddVendor() {
  const [formDataState, setFormDataState] = useState({});
  const post = usePost();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState({ ...formDataState, [name]: value });
  };
  console.log(formDataState);
  const onSuccess = (data) => {
    if (data.success === true) {
      CustomToast({
        type: "success",
        message: `request complete successfully`,
      });
    } else {
      CustomToast({ type: "error", message: `something went wrong` });
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Append other form data fields to FormData
    Object.keys(formDataState).forEach((key) => {
      if (key !== "images") {
        formData.append(key, formDataState[key]);
      }
    });

    // Append images to FormData
    formDataState.images.forEach((image, index) => {
      formData.append(`images[]`, image); // Append each image with a unique key
    });

    // Now 'formData' contains all form data including images, ready to be submitted
    await post.postData("add_vendor", formData, onSuccess);
  };
  const handleImageChange = (e) => {
    const selectedImages = Array.from(e.target.files); // Convert FileList to an array
    setFormDataState({ ...formDataState, images: selectedImages });
  };
  console.log(formDataState);
  return (
    <div className="row">
      <div className="col-md-8 offset-md-2">
        <form onSubmit={onSubmit} className="m-4 p-3 card ">
          <h6 className="text-center">Add Vendor</h6>

          <div className="row">
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">First Name</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="first_name"
                placeholder=""
                name="first_name"
                value={formDataState?.first_name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Last Name</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="last_name"
                placeholder=""
                name="last_name"
                value={formDataState?.last_name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Email</label>
              <input
                type="email"
                className="form-control border-bottom"
                id="email"
                placeholder=""
                name="email"
                value={formDataState?.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">password</label>
              <input
                type="password"
                className="form-control border-bottom"
                id="password"
                placeholder=""
                name="password"
                value={formDataState?.password}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Company Name</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="company_name"
                placeholder=""
                name="company_name"
                value={formDataState?.company_name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Country</label>
              <select
                name="country"
                value={formDataState?.country}
                onChange={handleChange}
                className="form-control border-bottom"
              >
                <option selected hidden>
                  Sleect country
                </option>

                {countries &&
                  countries.map((country) => (
                    <option value={country?.name}>{country?.name}</option>
                  ))}
              </select>
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Phone</label>
              <input
                type="tel"
                className="form-control border-bottom"
                id="phone"
                placeholder=""
                name="phone"
                value={formDataState?.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Address</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="address"
                placeholder=""
                name="address"
                value={formDataState?.address}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Location</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="location"
                placeholder=""
                name="location"
                value={formDataState?.location}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">City</label>
              <input
                type="text"
                className="form-control border-bottom"
                id="city"
                placeholder=""
                name="city"
                value={formDataState?.city}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Wedding Capacity</label>
              <input
                type="number"
                className="form-control border-bottom"
                id="wedding_capacity"
                placeholder=""
                name="wedding_capacity"
                value={formDataState?.wedding_capacity}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Catering</label>
              <input
                type="number"
                className="form-control border-bottom"
                id="catering"
                placeholder=""
                name="catering"
                value={formDataState?.catering}
                onChange={handleChange}
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Extra Services</label>
              <input
                type="tel"
                className="form-control border-bottom"
                id="extra_services"
                placeholder=""
                name="extra_services"
                value={formDataState?.extra_services}
                onChange={handleChange}
                
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Accommodation</label>
              <br />
              <input
                type="radio"
                className="mr-3"
                id="accommodation1"
                placeholder=""
                defaultChecked
                name="accommodation"
                value="true"
                onClick={handleChange}
              />
              <label htmlFor="accommodation1">True</label>
              <input
                type="radio"
                className="mx-3"
                id="accommodation2"
                placeholder=""
                defaultChecked
                name="accommodation"
                value={"false"}
                onClick={handleChange}
              />
              <label htmlFor="accommodation2">False</label>
            </div>
            {formDataState?.accommodation === "true" ? (
              <div className="form-group col-md-6">
                <label htmlFor="floatingInput">Accommodation Capacity</label>
                <input
                  type="tel"
                  className="form-control border-bottom"
                  id="accommodation_capacity"
                  placeholder=""
                  name="accommodation_capacity"
                  value={formDataState?.accommodation_capacity}
                  onChange={handleChange}
                />
              </div>
            ) : null}

            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Logo</label>
              <input
                type="file"
                className="form-control "
                id="logo"
                placeholder=""
                name="logo"
                onChange={(e) =>
                  setFormDataState({
                    ...formDataState,
                    logo: e.target.files[0],
                  })
                }
              />
            </div>
            <div className="form-group col-md-6">
              <label htmlFor="floatingInput">Images</label>
              <input
                type="file"
                className="form-control custom-file"
                id="images"
                placeholder=""
                name="images"
                multiple
                onChange={handleImageChange}
              />
            </div>
          </div>

          <div className=" mt-2">
            <button className="btn btn-primary w-100 bg-book-now" type="submit">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
